const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
  ? JSON.parse(localStorage.getItem("currentUser"))
  : "";
const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;

export const defaultColumnsOrder = [
  "Slno",
  "Code",
  "Description",
  "Locn",
  "Unit",
  "Qty",
  "Unit Cost",
  "Amount",
  "x",
  "cntrl",
  "Frac",
  "Total",
  "OEM",
  "Group",
  "Disc%",
  "GIT",
  "isActive",
];

export const columnFieldMap = {
  Slno: "sino",
  Code: "code",
  Description: "description",
  Locn: "location",
  Unit: "unit",
  Qty: "qty",
  "Unit Cost": "unitCost",
  Amount: "amount",
  x: "x",
  cntrl: "cntrl",
  Frac: "fraction",
  Total: "total",
  OEM: "oem",
  Group: "group",
  "Disc%": "Discount%",
  GIT: "git",
  isActive: "isActive",
};

export const getBaseColumn = (
  field,
  widthMap,
  renderers,
  locationOptions,
  unitOptions,
  salespersonOptions
) => {
  const baseConfig = {
    field,
    headerName:
      Object.entries(columnFieldMap).find(
        ([, value]) => value === field
      )?.[0] || field,
    width: widthMap?.[field] || 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: false,
  };

  if (field === "vatEnabled") {
    return {
      ...baseConfig,
      headerName: "VAT",
      width: widthMap?.[field] || 60,
      renderCell: (params) => renderers.renderVatToggle(params, field),
    };
  }

  // Numeric fields
  if (
    [
      "qty",
      "unitCost",
      "unitBCCost",
      "amount",
      //   "othCost",
      "x",
      "cntrl",
      "fraction",
      "vatPercent",
      "vatAmount",
      "total",
      "Discount%",
    ].includes(field)
  ) {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderEditableCell(params, field, "number"),
    };
  }

  // Text fields
  if (
    [
      "code",
      "description",
      "mastInfo",
      "pono",
      "oem",
      "group",
      "git",
      "bin",
      "remarks",
      "dcp",
    ].includes(field)
  ) {
    return {
      ...baseConfig,
      renderCell: (params) => renderers.renderEditableCell(params, field),
    };
  }

  if (field === "location") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "location", locationOptions),
    };
  }

  if (field === "unit") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "unit", unitOptions),
    };
  }
  if (field === "salesperson") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "salesperson", salespersonOptions),
    };
  }
  if (field === "isActive") {
    return {
      ...baseConfig,
      headerName: "Active",
      width: widthMap?.[field] || 80,
      renderCell: (params) =>
        renderers.renderToggleCell(params, "isActive", "Yes", "No"),
    };
  }

  return baseConfig;
};

export const defaultColumnPercents = {
  sino: 5,
  code: 10,
  description: 20,
  location: 10,
  unit: 8,
  qty: 8,
  unitCost: 8,
  unitBCCost: 8,
  amount: 10,
  //   othCost: 8,
  "Discount%": 8,
  vatEnabled: 5,
  vatPercent: 8,
  vatAmount: 8,
  total: 10,
  actions: 5,
};

export const calculateRowValues = (item, documentData, context = {}) => {
  const qty = Number(item.qty) || 0;
  const unitCost = Number(item.unitCost) || 0;
  const discountPercent = Number(item["Discount%"]) || 0;

  if (String(item.isActive || "").toUpperCase() === "NO") {
    const negativeAmount = -(qty * unitCost);
    return {
      ...item,
      amount: negativeAmount.toFixed(2),
      othCost: "0.00",
      vatAmount: "0.00",
      vatPercent: 0,
      total: negativeAmount.toFixed(2),
      unitCost: unitCost,
    };
  }

  // 🔁 Manual total edit (reverse calculation)
  if (item._manualTotalEdit && item.total !== undefined && item.total !== "") {
    const manualTotal = Number(item.total) || 0;

    const grossBeforeDiscount =
      discountPercent > 0
        ? manualTotal / (1 - discountPercent / 100)
        : manualTotal;

    const recalculatedUnitCost = qty > 0 ? grossBeforeDiscount / qty : 0;

    return {
      ...item,
      unitCost: recalculatedUnitCost,
      amount: manualTotal.toFixed(2),
      total: manualTotal.toFixed(2),
      _manualTotalEdit: true,
    };
  }

  // ➡️ Normal forward calculation

  // Step 1: Discount per unit
  const discountPerUnit = unitCost * (discountPercent / 100);
  const unitCostAfterDiscount = unitCost - discountPerUnit;

  // Step 2: Line amount
  const amount = qty * unitCostAfterDiscount;

  return {
    ...item,
    unitCost: unitCostAfterDiscount,
    amount: amount.toFixed(2),
    total: amount.toFixed(2),
  };
};

export const getVatPercent = (purchaseData) => {
  return purchaseData?.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;
};

export const requiredFields = [
  "code",
  "description",
  "location",
  "unit",
  "qty",
  "unitCost",
];

export const newItemTemplate = (id, sino, defaultLocation) => ({
  id,
  sino,
  code: "",
  description: "",
  location: 'I',
  unit: "",
  qty: 0,
  unitCost: 0,
  amount: 0,
  x: 0,
  cntrl: 0,
  fraction: 0,
  vatEnabled: true,
  vatPercent: VATPERCENTAGE,
  vatAmount: 0,
  mastInfo: "",
  pono: "",
  total: 0,
  oem: "",
  group: "",
  "Discount%": 0,
  git: "",
  salesperson: "",
  bin: "",
  remarks: "",
  dcp: "",
  isIncluded: true,
  isActive: "Yes",
});

const screenCode = "PRODUCTION";

export const productiontableConfig = {
  columnFieldMap,
  defaultColumnsOrder,
  getBaseColumn,
  calculateRowValues,
  getVatPercent,
  screenCode,
  defaultColumnPercents,
  requiredFields,
  newItemTemplate,
};
